import { BaseEntity } from "@common/ADAPT.Common.Model/base-entity";
import { BreezeModelBuilder } from "@common/ADAPT.Common.Model/breeze-model-builder";
import { Partner } from "../partner/partner";
import { Organisation } from "./organisation";
import { ProgressCategory } from "./progress-category";

export class ProgressProduct extends BaseEntity<ProgressProduct> {
    public progressProductId!: number;
    public organisationId?: number;
    public partnerId?: number;
    public name!: string;
    public code?: string;
    public ordinal!: number;

    public organisation?: Organisation;
    public partner?: Partner;
    public progressCategories!: ProgressCategory[];
}

export const ProgressProductBreezeModel = new BreezeModelBuilder("ProgressProduct", ProgressProduct)
    .hasSource()
    .withIdField()
    .isOrganisationEntity()
    .orderBy("ordinal")
    .alwaysFetchingNestedNavigationProperty("progressCategories.progressItems")
    .build();
